import { Box, Button, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Modal, Select, TextField, Typography } from "@mui/material";
import styles from '../../../Pages/Integrations/Integration.module.css';
import CloseIcon from "@mui/icons-material/Close";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useEffect, useState } from "react";

const IntegrationModal = ({ modal, setModal, handleChange, apiKey, handleWixSubmit, formDetails, handleFormDetails, handleFormsSubmit, update, loading }) => {
    const [showPassword, setShowPassword] = useState(false);
    const [connectionType, setConnectionType] = useState('scp');

    useEffect(() => {
        if (formDetails?.connection_type) {
            setConnectionType(formDetails.connection_type);
        } else {
            setConnectionType('scp');
        }
    }, [formDetails?.connection_type, modal]);

    const getModalTitle = () => {
        if (modal === 'wix') return 'Wix Settings';
        if (modal === 'custom_site') return 'Custom Site Settings';
        if (modal === 'word_press') return 'WordPress Settings';
        return 'Settings';
    };

    return (
        <Modal
            open={modal?.length ? true : false}
            sx={{ "& .MuiBackdrop-root": { backgroundColor: "#13214440" } }}
            closeAfterTransition
        >
            <Box className={styles.modal_wrapper}>
                <Box className={styles.main_wrap}>
                    {/* Modal Header */}
                    <Box className={styles.modal_header}>
                        <Typography className={styles.modal_title}>{getModalTitle()}</Typography>
                        <IconButton className={styles.modal_close_btn} onClick={() => setModal(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {/* Modal Body */}
                    <Box className={styles.modal_body}>
                    {modal === 'wix' && <Box>
                        <Box className={styles.file_post_container}>
                            <InputLabel className={styles.post_label}>Api Key</InputLabel>
                            <TextField
                                multiline
                                minRows={6}
                                maxRows={10}
                                className={styles.file_post_input}
                                onChange={(e) => handleChange(e.target.value, 'api_key')}
                                value={apiKey?.api_key}
                                placeholder='Enter Api Key'
                            />
                        </Box>
                        <Box className={styles.file_post_container}>
                            <InputLabel className={styles.post_label}>Member Id</InputLabel>
                            <TextField
                                className={styles.file_post_input}
                                onChange={(e) => handleChange(e.target.value, 'member_id')}
                                value={apiKey?.member_id}
                                placeholder='Enter Member Id'
                            />
                        </Box>
                        <Box className={styles.file_post_container}>
                            <InputLabel className={styles.post_label}>Site Id</InputLabel>
                            <TextField
                                className={styles.file_post_input}
                                onChange={(e) => handleChange(e.target.value, 'site_id')}
                                value={apiKey?.site_id}
                                placeholder='Enter Site Id'
                            />
                        </Box>
                        <Box className={styles.btn_container}>
                            <Button variant='contained' className={styles.review_btn} onClick={() => handleWixSubmit()} disabled={loading}>{update ? 'update' : 'Submit'}</Button>
                        </Box>
                    </Box>}
                    {(modal === 'word_press' || modal === 'custom_site') && <Box>
                        {modal === 'custom_site' && <Box className={styles.file_post_container}>
                            <InputLabel className={styles.post_label}>Type</InputLabel>
                            <FormControl className={styles.file_post_input}>
                                <Select
                                    value={connectionType}
                                    onChange={(e) => {
                                        setConnectionType(e.target.value);
                                        handleFormDetails(e.target.value, 'connection_type');
                                    }}
                                    displayEmpty
                                >
                                    <MenuItem value="scp">SCP</MenuItem>
                                    <MenuItem value="ftp">FTP</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>}

                        {/* Username and Password side by side */}
                        <Box className={styles.field_row}>
                            <Box className={styles.field_half}>
                                <InputLabel className={styles.post_label}>Username</InputLabel>
                                <TextField
                                    className={styles.file_post_input}
                                    onChange={(e) => handleFormDetails(e.target.value, 'username')}
                                    value={formDetails?.username}
                                    placeholder='Enter username'
                                />
                            </Box>
                            <Box className={styles.field_half}>
                                <InputLabel className={styles.post_label}>Password</InputLabel>
                                <TextField
                                    type={showPassword ? "text" : "password"}
                                    className={styles.file_post_input}
                                    onChange={(e) => handleFormDetails(e.target.value, 'password')}
                                    value={formDetails?.password}
                                    placeholder='Enter password'
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => setShowPassword((prev) => !prev)}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>
                        </Box>

                        {connectionType === 'scp' && <Box className={styles.file_post_container}>
                            <InputLabel className={styles.post_label}>Application Name</InputLabel>
                            <TextField
                                className={styles.file_post_input}
                                onChange={(e) => handleFormDetails(e.target.value, 'app_name')}
                                value={formDetails?.app_name}
                                placeholder='Enter application name'
                            />
                        </Box>}
                        {modal === 'word_press' && <Box className={styles.file_post_container}>
                            <InputLabel className={styles.post_label}>Application Name</InputLabel>
                            <TextField
                                className={styles.file_post_input}
                                onChange={(e) => handleFormDetails(e.target.value, 'app_name')}
                                value={formDetails?.app_name}
                                placeholder='Enter application name'
                            />
                        </Box>}
                        {connectionType === 'ftp' && modal === 'custom_site' && <Box className={styles.file_post_container}>
                            <InputLabel className={styles.post_label}>FTP Host</InputLabel>
                            <TextField
                                className={styles.file_post_input}
                                onChange={(e) => handleFormDetails(e.target.value, 'ftp_host')}
                                value={formDetails?.ftp_host}
                                placeholder='Enter FTP host'
                            />
                        </Box>}
                        {(connectionType === 'scp' || modal === 'word_press') && <Box className={styles.file_post_container}>
                            <InputLabel className={styles.post_label}>Base Domain</InputLabel>
                            <TextField
                                className={styles.file_post_input}
                                onChange={(e) => handleFormDetails(e.target.value, 'base_domain')}
                                value={formDetails?.base_domain}
                                placeholder='https://example.com'
                            />
                        </Box>}
                        {(connectionType === 'scp' || modal === 'word_press') && <Box className={styles.file_post_container}>
                            <InputLabel className={styles.post_label}>Blog Path</InputLabel>
                            <TextField
                                className={styles.file_post_input}
                                onChange={(e) => handleFormDetails(e.target.value, 'blog_path')}
                                value={formDetails?.blog_path}
                                placeholder='Enter blog path'
                            />
                        </Box>}
                        {modal === 'custom_site' && connectionType === 'scp' && <Box className={styles.file_post_container}>
                            <InputLabel className={styles.post_label}>Server Location Path</InputLabel>
                            <TextField
                                className={styles.file_post_input}
                                onChange={(e) => handleFormDetails(e.target.value, 'target_location')}
                                value={formDetails?.target_location}
                                placeholder='Enter server location path'
                            />
                        </Box>}
                        {modal === 'custom_site' && connectionType === 'ftp' && <Box className={styles.file_post_container}>
                            <InputLabel className={styles.post_label}>Remote Base Path</InputLabel>
                            <TextField
                                className={styles.file_post_input}
                                onChange={(e) => handleFormDetails(e.target.value, 'remote_base_path')}
                                value={formDetails?.remote_base_path}
                                placeholder='Enter remote base path'
                            />
                        </Box>}
                        <Box className={styles.btn_container}>
                            <Button variant='contained' className={styles.review_btn} onClick={() => handleFormsSubmit()} disabled={loading}>{update ? 'update' : 'Submit'}</Button>
                        </Box>
                    </Box>}
                    </Box>{/* End modal_body */}
                </Box>
            </Box>
        </Modal>
    )
};

export default IntegrationModal;